export const ADD_ORDER_ITEM = 'ADD_ORDER_ITEM'
export const SET_ORDER_VALIDATION_ERRORS = 'SET_ORDER_VALIDATION_ERRORS'
export const CLEAR_ORDER_VALIDATION_ERRORS = 'CLEAR_ORDER_VALIDATION_ERRORS'
export const CLEAR_ORDER_VALIDATION_ERROR_BY_PROPERTY_PATH = 'CLEAR_ORDER_VALIDATION_ERROR_BY_PROPERTY_PATH'
export const CLEAR_ITEMS = 'CLEAR_ITEMS'
export const REMOVE_ITEM_FROM_ORDER_BY_ID = 'REMOVE_ITEM_FROM_ORDER_BY_ID'
export const SET_PRICE_SPECIFICATION = 'SET_PRICE_SPECIFICATION'
export const SET_PAY_IN_TERMS = 'SET_PAY_IN_TERMS'
export const SET_TERM_AGREEMENT = 'SET_TERM_AGREEMENT'
export const SET_CUSTOMER_DETAILS = 'SET_CUSTOMER_DETAILS'
export const SET_CUSTOMER_DETAILS_FIELD = 'SET_CUSTOMER_DETAILS_FIELD'
export const SET_INVOICE_ADDRESS = 'SET_INVOICE_ADDRESS'
export const SET_INVOICE_ADDRESS_FIELD = 'SET_INVOICE_ADDRESS_FIELD'
export const SET_DISCOUNT_CODE = 'SET_DISCOUNT_CODE'
export const SET_PAYMENT_SPECIFICATION = 'SET_PAYMENT_SPECIFICATION'
export const SET_TERMS_FOR_CART_ITEM = 'SET_TERMS_FOR_CART_ITEM'
export const CLEAR_TERMS_FOR_ALL_CART_ITEMS = 'CLEAR_TERMS_FOR_ALL_CART_ITEMS'
export const SET_ORDER_CREATED = 'SET_ORDER_CREATED'
export const SET_ORDER_STATUS = 'SET_ORDER_STATUS'
export const RESET_ORDER_STATUS = 'RESET_ORDER_STATUS'
export const SET_PAYMENT_METHOD_NAME = 'SET_PAYMENT_METHOD_NAME'
export const SET_PAYMENT_ISSUER_NAME = 'SET_PAYMENT_ISSUER_NAME'
export const RESET = 'RESET'
export const CLEAR_ORDER_CREATED = 'CLEAR_ORDER_CREATED'
export const SET_CUSTOMER_NUMBER = 'SET_CUSTOMER_NUMBER'
export const CLEAR_PAY_IN_TERMS = 'CLEAR_PAY_IN_TERMS'
export const SET_COMBI_DEAL_DISCOUNT_SUGGESTIONS = 'SET_COMBI_DEAL_DISCOUNT_SUGGESTIONS'
export const CUSTOMER_DETAILS_CHANGED = 'CUSTOMER_DETAILS_CHANGED'
export const SET_SHOP = 'SET_SHOP'
export const CLEAR_SHOP = 'CLEAR_SHOP'

export default {
  ADD_ORDER_ITEM,
  SET_ORDER_VALIDATION_ERRORS,
  CLEAR_ORDER_VALIDATION_ERRORS,
  CLEAR_ITEMS,
  REMOVE_ITEM_FROM_ORDER_BY_ID,
  SET_PRICE_SPECIFICATION,
  SET_PAY_IN_TERMS,
  SET_CUSTOMER_DETAILS,
  SET_CUSTOMER_DETAILS_FIELD,
  SET_INVOICE_ADDRESS,
  SET_INVOICE_ADDRESS_FIELD,
  SET_TERM_AGREEMENT,
  SET_DISCOUNT_CODE,
  SET_PAYMENT_SPECIFICATION,
  SET_TERMS_FOR_CART_ITEM,
  CLEAR_TERMS_FOR_ALL_CART_ITEMS,
  SET_ORDER_CREATED,
  SET_ORDER_STATUS,
  SET_PAYMENT_METHOD_NAME,
  SET_PAYMENT_ISSUER_NAME,
  RESET,
  CLEAR_ORDER_CREATED,
  SET_CUSTOMER_NUMBER,
  RESET_ORDER_STATUS,
  CLEAR_PAY_IN_TERMS,
  SET_COMBI_DEAL_DISCOUNT_SUGGESTIONS,
  CUSTOMER_DETAILS_CHANGED,
  SET_SHOP,
  CLEAR_SHOP
}



// WEBPACK FOOTER //
// ./src/store/modules/cart/mutation-types.js